// var touchStart = {
//     setup: function (_, ns, handle) {
//         this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
//     },
// };
// var touchMove = {
//     setup: function (_, ns, handle) {
//         this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
//     },
// };

function initSlider() {
    $('.s-slider-final').each(function () {
        var s = $(this);
        let wrap = s.find('.s-slider-final__wrap');
        let firstSlide = wrap.find('.s-slider-final__slide.active');
        console.log(firstSlide);

        let offset = firstSlide.offset().left - wrap.offset().left;
        console.log(offset);
        let nextBtn = s.find('.next');
        let prevBtn = s.find('.prev');
        let nextSlide;
        let prevSlide;
        let xOffset = 0;
        let dragging = false;
        let startPos;
        let totalDistance = 0;
        let activeSlide = firstSlide;

        wrap.on('mousedown touchstart', function (e) {
            dragging = true;
            if ($(window).width() <= 1024) {
                startPos = e.touches[0].clientX;
            } else {
                startPos = e.pageX;
            }
        });

        wrap.on('mousemove touchmove', function (e) {
            if (dragging) {
                let pageX = e.pageX;
                if ($(window).width() <= 1024) {
                    let clientX = e.touches[0].clientX;
                    totalDistance = clientX - startPos;
                } else {
                    totalDistance = pageX - startPos;
                }
            }
        });

        wrap.on('mouseup touchend', function () {
            if (totalDistance < 0 && totalDistance < -50) {
                nextBtn.trigger('click');
            }
            if (totalDistance > 0 && totalDistance > 50) {
                prevBtn.trigger('click');
            }
            dragging = false;
            totalDistance = 0;
        });

        nextBtn.on('click', function () {
            if (!wrap.hasClass('disabled')) {
                wrap.addClass('disabled');
                let slides = s.find('.s-slider-final__slide');
                let firstSlide = slides.first();

                xOffset = xOffset + firstSlide.outerWidth(true);
                nextSlide = activeSlide.next();
                offset = offset + activeSlide.outerWidth(true);

                wrap.css('margin-left', -offset);

                activeSlide.removeClass('active');
                activeSlide = nextSlide.addClass('active');

                setTimeout(function () {
                    wrap.append(firstSlide);
                    wrap.css('transform', 'translateX(' + xOffset + 'px)');
                    wrap.removeClass('disabled');
                }, 251);
            }
        });

        prevBtn.on('click', function () {
            if (!wrap.hasClass('disabled')) {
                wrap.addClass('disabled');
                let slides = s.find('.s-slider-final__slide');
                let lastSlide = slides.last();

                xOffset = xOffset - lastSlide.outerWidth(true);
                prevSlide = activeSlide.prev();
                offset = offset - prevSlide.outerWidth(true);

                wrap.css('margin-left', -offset);

                activeSlide.removeClass('active');
                activeSlide = prevSlide.addClass('active');

                setTimeout(function () {
                    wrap.prepend(lastSlide);
                    wrap.css('transform', 'translateX(' + xOffset + 'px)');
                    wrap.removeClass('disabled');
                }, 251);
            }
        });
    });
}

// make sure this only fires after the initial cloning and animation is complete
setTimeout(function () {
    initSlider();
}, 900);



// WEBPACK FOOTER //
// ./scripts/routes/sections/slider-swiper.js